module.exports = __webpack_public_path__ + "static/img/img_IPmin_1.7ce8b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/img_IPmin_1.png
// module id = 95if
// module chunks = 0